<template>
  <div
    id="modal_container-confirm"
    class="modal_container"
    :class="{active: modalConfirm.open}"
    @click="close"
  >
    <div class="modal txt-center" @click.stop>
      <div class="close_btn h2" @click="close"><span>×</span></div>
      <div class="modal_content mg-b-50">
        <p class="txt-bold" v-html="modalConfirm.message"></p>
      </div>
      <div class="modal_confirm dual_btn">
        <button
          type="button"
          class="btn p btn_cancel"
          @click="handleCancel"
        >
          {{ modalConfirm.cancelText }}
        </button>
        <button
          type="button"
          class="btn p btn_confirm"
          @click="handleConfirm"
        >
          {{ modalConfirm.confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ModalConfirm',
  computed: {
    ...mapGetters([
      'modalConfirm',
    ]),
  },
  methods: {
    ...mapMutations([
      'toggleModalConfirm',
    ]),
    close() {
      this.toggleModalConfirm(false);
    },
    handleConfirm() {
      this.close();
      if (this.modalConfirm.confirmUrl) {
        this.$router.push({ path: this.modalConfirm.confirmUrl });
      }
    },
    handleCancel() {
      this.close();
      if (this.modalConfirm.cancelUrl) {
        this.$router.push({ path: this.modalConfirm.cancelUrl });
      }
    },
  },
  watch: {
    'modalConfirm.open': function (newVal) {
      const el = document.getElementsByTagName('body')[0];
      if (newVal) {
        el.classList.add('lock');
      } else {
        el.classList.remove('lock');
      }
    },
    $route() {
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.dual_btn {
  display: flex;
  justify-content: center;
  gap: 20px;
  .btn {
    min-width: 180px !important;
    width: auto !important;
    padding: 0 35px !important;
    white-space: nowrap !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    &.btn_cancel {
      background-color: #999;
      &:hover {
        background-color: #777;
      }
    }
  }
}
</style>
